import Types from "./Types";
/* eslint-disable camelcase */
/************************************************
GET ASN BATCHES
*************************************************/

const getAsnBatchesImport = query => {
  return {
    type: Types.GET_ASN_BATCHES_IMPORT,
    query
  };
};

const getAsnBatchesImportSuccess = batches => {
  return {
    type: Types.GET_ASN_BATCHES_IMPORT_SUCCESS,
    batches
  };
};

const getAsnBatchesImportFailure = error => ({
  type: Types.GET_ASN_BATCHES_IMPORT_FAILURE,
  error
});

/************************************************
GET ASN BATCHES FOR STOCK
*************************************************/

const getAsnBatchesStock = query => {
  return {
    type: Types.GET_ASN_BATCHES_STOCK,
    query
  };
};

const getAsnBatchesStockSuccess = stockBatches => {
  return {
    type: Types.GET_ASN_BATCHES_STOCK_SUCCESS,
    stockBatches
  };
};

const getAsnBatchesStockFailure = error => ({
  type: Types.GET_ASN_BATCHES_STOCK_FAILURE,
  error
});

//GET lines

const getImportLines = (query, isExport) => {
  return {
    type: Types.GET_IMPORT_LINES,
    query,
    isExport
  };
};

const getImportLinesSuccess = lines => {
  return {
    type: Types.GET_IMPORT_LINES_SUCCESS,
    lines
  };
};

const getImportLinesFailure = error => ({
  type: Types.GET_IMPORT_LINES_FAILURE,
  error
});

// GET stock lines

const getStockLines = (query, isExport) => {
  return {
    type: Types.GET_STOCK_LINES,
    query,
    isExport
  };
};

const getStockLinesSuccess = stockLines => {
  return {
    type: Types.GET_STOCK_LINES_SUCCESS,
    stockLines
  };
};

const getStockLinesFailure = error => ({
  type: Types.GET_STOCK_LINES_FAILURE,
  error
});

/* Export offer stock */
const exportStock = () => {
  return {
    type: Types.EXPORT_STOCK
  };
};

const exportStockSuccess = () => {
  return {
    type: Types.EXPORT_STOCK_SUCCESS
  };
};

const exportStockFailure = error => {
  return {
    type: Types.EXPORT_STOCK_FAILURE,
    error
  };
};

/* importStock */
const importStock = (stock: Object, params: string) => {
  return {
    type: Types.IMPORT_STOCK,
    stock,
    params
  };
};

const importStockSuccess = (documentBatchId, params: string) => {
  return {
    type: Types.IMPORT_STOCK_SUCCESS,
    documentBatchId,
    params
  };
};

const importStockFailure = (error: Object) => {
  return {
    type: Types.IMPORT_STOCK_FAILURE,
    error
  };
};


export {
  getAsnBatchesImport,
  getAsnBatchesImportSuccess,
  getAsnBatchesImportFailure,
  getImportLines,
  getImportLinesSuccess,
  getImportLinesFailure,
  getAsnBatchesStock,
  getAsnBatchesStockSuccess,
  getAsnBatchesStockFailure,
  getStockLines,
  getStockLinesSuccess,
  getStockLinesFailure,
  exportStock,
  exportStockSuccess,
  exportStockFailure,
  importStock,
  importStockSuccess,
  importStockFailure
};



// WEBPACK FOOTER //
// ./src/actions/ImportActions.js